import ConversationItem from '../conversation_item';
import createModel, { prop } from '../lib/create_model';
import NotificationType from './notification_type';
import { SessionCustomer } from '../active_session';

export default createModel({
  modelName: 'IncomingConcurrentMessageNotification',

  properties: {
    id: prop(String), // AD only field
    conversationId: prop(String),
    conversationItem: prop(ConversationItem),
    profile: prop(SessionCustomer),
  },

  overrideToJs(toJs) {
    return () => ({ ...toJs(), type: NotificationType.INCOMING_CONCURRENT_MESSAGE });
  },
});



// WEBPACK FOOTER //
// ./src/scripts/domain/models/notification/incoming_concurrent_message_notification.js